import * as React from 'react';
export var IconArrowLeft = React.forwardRef(function IconArrowLeft({ size = 24, ...other }, ref) {
    if (size === 16 || size === '16') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '16',
            height: '16',
            viewBox: '0 0 16 16',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-sm': true
        }, /*#__PURE__*/ React.createElement('path', {
            d: 'M3.24 7.45a.75.75 0 0 0 0 1.1l3.5 3.25a.75.75 0 0 0 1.02-1.1l-2.1-1.95h6.587a.75.75 0 1 0 0-1.5H5.662L7.76 5.303a.75.75 0 0 0-1.02-1.1L3.24 7.45Z',
            fill: 'currentColor',
            'data-global-icon-size-sm': true
        }));
    }
    if (size === 24 || size === '24') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-md': true
        }, /*#__PURE__*/ React.createElement('path', {
            d: 'M5.234 11.458a.75.75 0 0 0 0 1.085l5.498 5.245a.75.75 0 1 0 1.036-1.085L7.624 12.75h10.628a.75.75 0 0 0 0-1.5H7.622l4.146-3.96a.75.75 0 1 0-1.036-1.085l-5.498 5.253Z',
            fill: 'currentColor',
            'data-global-icon-size-md': true
        }));
    }
    if (size === 32 || size === '32') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-lg': true
        }, /*#__PURE__*/ React.createElement('path', {
            d: 'M5.234 11.458a.75.75 0 0 0 0 1.085l5.498 5.245a.75.75 0 1 0 1.036-1.085L7.624 12.75h10.628a.75.75 0 0 0 0-1.5H7.622l4.146-3.96a.75.75 0 1 0-1.036-1.085l-5.498 5.253Z',
            fill: 'currentColor',
            'data-global-icon-size-lg': true
        }));
    }
});
